import { Menu, Position } from "@blueprintjs/core"
import React from "react"
import CustomButton, { CustomButtonProps } from "./CustomButton"
import CustomPopover, { CustomPopoverProps } from "./CustomPopover"

type ActionMenuProps = CustomButtonProps & {
  /*
    menuClassName: a string used for uniquely identifying the menu
  */
  menuClassName?: string
  /*
    popoverProps: an object which contains popover props which the user can spread
  */
  popoverProps?: CustomPopoverProps
  children?: React.ReactNode
}
const ActionMenu = ({
  children,
  popoverProps,
  menuClassName,
  className,
  ...otherProps
}: ActionMenuProps) => {
  return (
    <CustomPopover
      position={Position.BOTTOM_LEFT}
      minimal={true}
      content={<Menu className={menuClassName}>{children}</Menu>}
      {...popoverProps}
    >
      <CustomButton
        style={{ transform: "rotate(90deg)" }}
        icon="more"
        minimal={true}
        className={className}
        {...otherProps}
      />
    </CustomPopover>
  )
}

export default ActionMenu
